import { useQuery } from "react-query";
import { api } from "utils/api";
import { ContentData } from "../types";

const getResources = () => api.get<ContentData[]>(`/resources`);

const useResources = () => useQuery(["resources"], getResources);

export { useResources };
